import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import { publicRoutes } from '@app/router/publicRoutes'
import { privateRoutes } from '@app/router/privateRoutes'
import { signUpRoutes, onboardingWizardRoutes } from '@modules/onboarding'
import constants from '@shared/constants'
import localStorageService from '@core/persistence/localStorage/localStorageService'
// Layouts come from the active pack — swap packs in `src/app/layouts/index.ts`.
import { AppLayout, AuthLayout, SignUpLayout, OnboardingLayout } from '@app/layouts'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
    component: AuthLayout,
    children: [...publicRoutes],
  },
  // Sign-up — pre-auth acquisition surface with the trust-dossier shell.
  // Separated from the KYC wizard so each layer can diverge in design.
  {
    path: '/',
    component: SignUpLayout,
    children: [...signUpRoutes],
  },
  // Post-signup KYC wizard — authed but pre-dashboard.
  {
    path: '/',
    component: OnboardingLayout,
    children: [...onboardingWizardRoutes],
  },
  {
    path: '/',
    component: AppLayout,
    children: [...privateRoutes],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const token = localStorageService.getItem(constants.LOCAL_STORAGE_KEYS.TOKEN)

  const isAuthenticated = Boolean(token)

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  const requiresGuest = to.matched.some((record) => record.meta.requiresGuest)

  if (requiresAuth && !isAuthenticated) {
    return { name: 'LOGIN', path: '/login' }
  }

  if (requiresGuest && isAuthenticated) {
    return { path: '/dashboard' }
  }

  return true
})

export default router
